export const STUDENT_BASE = '/candidate';

export const courses = [
  { id: 'c0', icon: 'mega', from: '#8b5cf6', to: '#ec4899', title: 'Digital Marketing Fundamentals', category: 'Marketing', rating: 4.8 },
  { id: 'c1', icon: 'code', from: '#2563eb', to: '#facc15', title: 'Python for Beginners', category: 'Technology', rating: 4.7 },
  { id: 'c2', icon: 'mic', from: '#0ea5e9', to: '#6366f1', title: 'Communication & Presentation', category: 'Soft Skills', rating: 4.6 },
  { id: 'c3', icon: 'table', from: '#16a34a', to: '#4ade80', title: 'Data Analysis with Excel', category: 'Business', rating: 4.5 },
];

export const jobs = [
  { id: 'Marketing Intern', icon: 'chart', from: '#10b981', to: '#059669', title: 'Marketing Intern', company: 'GrowthX Media', meta: 'Remote · 3–6 months', type: 'Internship', tags: ['Marketing', 'Communication'] },
  { id: 'Full Stack Developer', icon: 'code', from: '#2563eb', to: '#60a5fa', title: 'Full Stack Developer', company: 'TechNova', meta: 'Bangalore · Full-time', type: 'Jobs', tags: ['Development', 'Python'] },
  { id: 'Business Analyst Intern', icon: 'table', from: '#f97316', to: '#fb923c', title: 'Business Analyst Intern', company: 'FinNext', meta: 'Delhi · 3 months', type: 'Internship', tags: ['Analytics', 'Problem Solving'] },
  { id: 'Content Creator', icon: 'palette', from: '#ef4444', to: '#f472b6', title: 'Content Creator', company: 'WeLearn', meta: 'Remote · Part-time', type: 'Jobs', tags: ['Creativity', 'Communication'] },
];

export const clubs = [
  { id: 'k0', icon: 'robot', from: '#4f46e5', to: '#818cf8', title: 'Robotics Club', event: 'Workshop · Tomorrow, 4:00 PM', members: 248, xp: 320 },
  { id: 'k1', icon: 'palette', from: '#ec4899', to: '#f97316', title: 'Design Club', event: 'Creative Showcase · Sat, 11:00 AM', members: 182, xp: 210 },
  { id: 'k2', icon: 'ball', from: '#16a34a', to: '#22d3ee', title: 'Sports Club', event: 'Inter-College Match · Sun, 5:00 PM', members: 156, xp: 180 },
];

export const badges = [
  { icon: 'learn', from: '#3b82f6', to: '#1d4ed8', title: 'First Course Completed' },
  { icon: 'flame', from: '#fb923c', to: '#f59e0b', title: '7-Day Streak' },
  { icon: 'target', from: '#8b5cf6', to: '#6366f1', title: 'Quiz Master' },
  { icon: 'bulb', from: '#38bdf8', to: '#2563eb', title: 'Innovation Explorer' },
  { icon: 'users', from: '#4ade80', to: '#16a34a', title: 'Community Builder' },
  { icon: 'job', from: '#f97316', to: '#ef4444', title: 'Career Ready' },
  { icon: 'ball', from: '#ef4444', to: '#f43f5e', title: 'Sports Champion', locked: true },
  { icon: 'crown', from: '#8b5cf6', to: '#7c3aed', title: 'Student Leader', locked: true },
  { icon: 'leaf', from: '#22c55e', to: '#16a34a', title: 'Social Impact', locked: true },
];

export const feed = [
  { name: 'Rahul', text: 'completed Python Fundamentals', time: '2h ago', likes: 24, comments: 3 },
  { name: 'Priya', text: 'won a debate competition', time: '4h ago', likes: 56, comments: 7 },
  { name: 'Arjun', text: 'shared his internship experience', time: '6h ago', likes: 48, comments: 5 },
];

export const picks = [
  { icon: 'learn', from: '#2563eb', to: '#4f46e5', title: 'Advanced Digital Marketing', reason: 'Based on your Digital Marketing course', action: 'View Course' },
  { icon: 'job', from: '#10b981', to: '#0ea5e9', title: 'Marketing Intern – Chandigarh', reason: 'Matches your skills & interests', action: 'View Job' },
  { icon: 'insta', from: '#f97316', to: '#ec4899', title: 'Photography Club Workshop', reason: 'Based on your club interests', action: 'Join Event' },
];

export const profileStats = [
  { icon: 'learn', value: '6', label: 'Courses' },
  { icon: 'job', value: '2', label: 'Internships' },
  { icon: 'award', value: '8', label: 'Achievements' },
  { icon: 'users', value: '3', label: 'Clubs' },
  { icon: 'trophy', value: '14', label: 'Badges' },
  { icon: 'chart', value: '82%', label: 'Career ready' },
];

export const skills = ['Digital Marketing', 'Communication', 'Python', 'Leadership', 'Problem Solving'];

export const shareTargets = [
  { icon: 'phone', color: '#22c55e', label: 'WhatsApp' },
  { icon: 'insta', color: '#ec4899', label: 'Instagram' },
  { icon: 'user', color: '#0a66c2', label: 'LinkedIn' },
  { icon: 'trophy', color: '#4f46e5', label: 'Focalyt' },
];
